import { createClient } from '@supabase/supabase-js'

// A separate client: do not replace the existing Codevaro Cloud client before data migration.
const endpoint = 'https://api.codevaro.eu'
const publishableKey = import.meta.env.VITE_EURONODES_SUPABASE_ANON_KEY
export const euronodesAuth = publishableKey
  ? createClient(endpoint, publishableKey, {
      auth: {
        storageKey: 'codevaro-euronodes-auth',
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: false
      }
    })
  : null

// GoTrue implicit-flow callbacks arrive as #access_token=...;
// React Router uses #/route. Capture the fragment before mounting that router.
const rawHash = window.location.hash
const params = rawHash.startsWith('#access_token=') || rawHash.startsWith('#error=')
  ? new URLSearchParams(rawHash.slice(1))
  : null

export const initialAuthCallback = params
  ? {
      accessToken: params.get('access_token'),
      refreshToken: params.get('refresh_token'),
      error: params.get('error_description') || params.get('error'),
      type: params.get('type')
    }
  : null

if (params) {
  // Remove the sensitive tokens from the address bar immediately.
  window.history.replaceState(window.history.state, '', '/#/auth/complete')
}